import { Pipe, PipeTransform } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Pipe({
  name: 'appNgbDateToDate'
})
export class NgbDateToDatePipe implements PipeTransform {
  public transform(value: NgbDateStruct | null): Date | null {
    return value ? new Date(`${value.month}/${value.day}/${value.year}`) : null;
  }
}
